/**
 * 薬歴関連の定数定義
 */

/**
 * ページネーション設定
 */
export const YAKUREKI_PAGINATION = {
  /** 1ページあたりの取得件数 */
  PAGE_SIZE: 100,
  /** 最大ページ数（安全装置） */
  MAX_PAGES: 100,
  /** 最大取得可能レコード数 */
  MAX_RECORDS: 10000,
} as const
